export const RouteNames = {
  HOME: '/',
  PREPAIR_DELETE_USER: '/prepair/delete_user',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy'
};
